// components
import maAdminView from '../adminView'
import maFilters from '../../components/filters'
import maPaginator from '@/components/paginator'
import maModal from '@/components/modal'
import maInputText from '@/components/input/modules/text'
import maInputSelect from '@/components/input/modules/select'
import maEmpty from '@/components/empty'

// utils
import debounce from '@/utils/debounce'

// api
import {
  apiGetAdminZipCodes,
  apiPatchAdminZipCodes,
  apiDeleteAdminZipCodes,
  apiGetCountries
} from '@/services/API/adminGag'

export default {
  name: 'zipCodes',
  data: function () {
    return {
      zipCode: {
        clean_cost: null,
        coef: null,
        dept_code: null,
        displacement_hours: null,
        factmin: null,
        zip_code_min: null,
        zip_code_max: null,
        country: null,
        selected_country: null
      },
      countries: [],
      zipCodeFilterText: '',
      filterTableByZipCodeDebounced: debounce(this.filterTableByZipCode, 200)
    }
  },
  extends: maAdminView,
  components: {
    maPaginator,
    maFilters,
    maModal,
    maInputText,
    maInputSelect,
    maEmpty
  },
  methods: {
    handleSearch: function () {
      apiGetAdminZipCodes(this.currentPage, this.zipCodeFilterText)
        .then(repMat => {
          this.table = repMat.results
          this.totalPages = repMat.total_pages || 0
        })
    },
    handleEdit: function (data) {
      this.zipCode = data
      this.zipCode.selected_country = data.country
      this.getCountries()
      this.$refs.adminGagEditModal.showModal = true
    },
    handleDelete: function (data) {
      apiDeleteAdminZipCodes(data).then(() => {
        this.handleSearch()
        this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
      })
    },
    handleSave: function () {
      apiPatchAdminZipCodes(this.zipCode)
        .then(() => {
          this.handleSearch()
          this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
          this.$refs.adminGagEditModal.showModal = false
        })
        .catch(() => {
          this.throwNotification(this.$t('notifications.error.0.title'), this.$t('notifications.error.0.body'), 'KO')
        })
    },
    resetEditValues: function () {
      if (this.zipCode) {
        Object.keys(this.zipCode).forEach(item => (item = null))
      }
    },
    filterTableByZipCode (zipCodeFilter) {
      this.zipCodeFilterText = zipCodeFilter
      this.handleSearch()
    },
    getCountries: function () {
      apiGetCountries()
        .then(countries => {
          this.countries = countries
        })
        .catch(err => {
          console.debug('err', err)
          this.triggerModalError()
        })
    }
  }
}
